export type RoleId = "owner" | "manager" | "analyst";
export type UserState = "active" | "invited" | "suspended";

export interface Role {
  id: RoleId;
  label: string;
  summary: string;
  permissions: string[];
}

export const roles: Role[] = [
  {
    id: "owner",
    label: "Brand owner",
    summary: "Full control, including users and exports.",
    permissions: [
      "View all leads",
      "Log outcomes",
      "Delete leads",
      "Configure delivery",
      "Manage users",
      "Export data",
    ],
  },
  {
    id: "manager",
    label: "Manager",
    summary: "Runs the lead pipeline and delivery setup.",
    permissions: ["View all leads", "Log outcomes", "Configure delivery", "Export data"],
  },
  {
    id: "analyst",
    label: "Analyst",
    summary: "Works leads day to day; cannot change delivery.",
    permissions: ["View all leads", "Log outcomes"],
  },
];

export const roleMeta: Record<RoleId, Role> = Object.fromEntries(
  roles.map((role) => [role.id, role]),
) as Record<RoleId, Role>;

export interface BrandUser {
  id: string;
  name: string;
  email: string;
  role: RoleId;
  state: UserState;
  lastActive: string;
}

export const userStateMeta: Record<
  UserState,
  { label: string; tone: "green" | "amber" | "neutral" }
> = {
  active: { label: "Active", tone: "green" },
  invited: { label: "Invite pending", tone: "amber" },
  suspended: { label: "Suspended", tone: "neutral" },
};
